import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
export function template() {
  return jsx("div", {
    sel: '.mp-step-range'
  }, this.attr("label") ? jsx("div", {
    sel: '.mp-step-range-label'
  }, this.attr("label")) : null, jsx(SelectEl, {
    attrs: {
      sections: JSON.stringify(this.helpers.getOptions()),
      theme: this.attr("theme"),
      'menu-width': 140,
      disabled: this.attr("disabled"),
      tooltip: this.attr("tooltip") && {
        text: this.attr("tooltip")
      }
    },
    on: {
      change: this.helpers.onChange
    }
  }));
}